export default __webpack_public_path__ + "static/media/sushant.51b8b52e.png";